// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page-container{
    padding: 1rem;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage/ErrorPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf","sourcesContent":[".error-page-container{\n    padding: 1rem;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
